import React from 'react'
import tw from 'tailwind-styled-components'
import {Lang} from 'yougile-lang'
import {Util} from 'yougile-util'
import {DataObjectId, Hub} from 'yougile-model'
import {Sync} from '@client/sync'
import {TaskChatQuickLinkList} from '@components/chat/chat-header/task-chat-quick-link-list'
import {Icon} from '@components/common/base/icon'
import {DivWithHint} from '@components/common/hint/hint'
import {FullTaskChatProxy} from '@extensions/proxies/full-task-chat-proxy'
import {ChatNav} from './chat-nav'

const TwFeedbackChatHeader = tw.div`
  pb-12
  px-24
  flex
  gap-8
`

const TwContent = tw.div`
  min-w-0
  flex
  flex-col
  gap-8
`

const TwChatName = tw(DivWithHint)`
  min-w-0
  font-semibold
  text-18
  leading-6
  text-primary
  break-words
`

const TwMessage = tw.div`
  plain-text-regular
  text-placeholder
`

const FeedbackHeaderBase = ({
  chatName,
  chatId,
  companyId
}: {
  chatName: string
  chatId: DataObjectId
  companyId: DataObjectId
}) => (
  <>
    <ChatNav />
    <TwFeedbackChatHeader>
      <Icon color="secondary" icon="IconHeadset" size={24} />
      <TwContent>
        <TwChatName content={chatName}>
          {Util.limitStr(chatName, 150)}
        </TwChatName>
        <TwMessage>{Lang.msg.feedbackChatDescription}</TwMessage>
      </TwContent>
    </TwFeedbackChatHeader>
    <TaskChatQuickLinkList chatId={chatId} companyId={companyId} />
  </>
)

export const FeedbackHeader = ({chatId}: {chatId: DataObjectId}) => {
  const box = Sync.get({companyId: Sync.profileId})
  const hub = box && (box.get(chatId) as Hub)
  const task = hub && FullTaskChatProxy.createForCurrentUser(hub)

  return task ? (
    <FeedbackHeaderBase
      chatId={chatId}
      companyId={task.companyId}
      chatName={task.chatName}
    />
  ) : null
}
